// src/components/library/BookCarousel.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { fetchBooks } from '../../services/bookService'; 
import BookCard from './BookCard'; 

const BookCarousel = ({ title, fetchParams, viewMoreLink }) => {
    const [books, setBooks] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadBooks = async () => {
            setLoading(true);
            try {
                const response = await fetchBooks({ ...fetchParams, limit: 10 });
                const data = response.data;
                // ✅ بررسی: اگر data یک آرایه است، از آن استفاده کن
                // ✅ در غیر این صورت اگر data.results وجود دارد، از آن استفاده کن
                const booksArray = Array.isArray(data) ? data : (data?.results || []);
                setBooks(booksArray);
            } catch (error) {
                console.error(`خطا در واکشی کراسل '${title}':`, error);
            } finally {
                setLoading(false);
            }
        };
        
        loadBooks();
    }, [fetchParams, title]); 

    return (
        <div className="w-full mb-8">
            <div className="flex justify-between items-center mb-4 rtl text-right px-1">
                <h3 className="text-[14px] font-medium text-gray-600">{title}</h3>
                {viewMoreLink && (
                    <Link 
                        to={viewMoreLink} 
                        className="flex items-center text-[11px] text-gray-400 hover:text-indigo-800 transition-colors"
                    >
                        <span>بیشتر</span>
                        <ChevronLeft size={18} />
                    </Link>
                )}
            </div>
            
            <div className="flex overflow-x-auto gap-5 pb-4 px-1 flex-nowrap">
                {loading ? (
                    Array.from({ length: 3 }).map((_, index) => (
                        <div key={index} className="w-[280px] h-[200px] flex-shrink-0 bg-gray-100 rounded-xl animate-pulse"></div>
                    ))
                ) : books.length === 0 ? (
                    <div className="text-gray-400 py-4">هیچ کتابی یافت نشد.</div>
                ) : (
                    books.map((book) => (
                        <div key={book.id} className="w-[280px] flex-shrink-0">
                            <BookCard book={book} />
                        </div>
                    ))
                )}
            </div>
        </div>
    );
};

export default BookCarousel;